export default __webpack_public_path__ + "static/media/KyleShannon.baea4550.png";